// The month grid of the coach's workout calendar (same maths as the member's page on the public site).

/** "2026-10" for a month and a step (+1 / -1). */
export function shiftMonth(month, step) {
  const [y, m] = month.split("-").map(Number);
  const d = new Date(Date.UTC(y, m - 1 + step, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
}

/** Leading blanks, then every day of the month as "YYYY-MM-DD". weekStart 0 = Sunday ... 6 = Saturday. */
export function monthCells(month, weekStart) {
  const [y, m] = month.split("-").map(Number);
  const first = new Date(Date.UTC(y, m - 1, 1));
  const days = new Date(Date.UTC(y, m, 0)).getUTCDate();
  const lead = (first.getUTCDay() - weekStart + 7) % 7;
  const cells = Array(lead).fill(null);
  for (let d = 1; d <= days; d++) cells.push(`${month}-${String(d).padStart(2, "0")}`);
  return cells;
}

export function byDay(entries) {
  const map = {};
  (entries || []).forEach((e) => {
    (map[e.day] = map[e.day] || []).push(e);
  });
  return map;
}

/** Today in Cairo as YYYY-MM-DD (where the coaches are). */
export function todayCairo(now = new Date()) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Africa/Cairo", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
}

/** After dragging entry `id` onto `day`: the entries with that one moved (shown at once, the server confirms). */
export function moveEntry(entries, id, day) {
  return (entries || []).map((e) => (e.id === id ? { ...e, day } : e));
}
